module.exports = __webpack_public_path__ + "media/images/defaultguides-62fada9c.png";